import axios from 'axios'

export const NotesPageApi = {
    http: axios.create(),

    async getPageInfo() {
        const routeUri = Routing.generate("api_notes_page_info");
        let response = await this.http.get(routeUri);
        return response.data.info;
    },
};
